
import { Component, Prop, Vue } from "vue-property-decorator";
import Tab from "@/interfaces/Tab";

@Component({
  components: {},
})
export default class Tabs extends Vue {

  get OnlyOnTab() {
    return this.tabs ? this.tabs.length === 1 : false;
  }
  @Prop({ default: "" })
  public activeTabLabel: string;

  @Prop({ default: [] })
  private tabs: Tab[];

  private changeTabs(tab: Tab) {
    this.$emit("update-active-tab", tab);
  }
}
